// extracted by mini-css-extract-plugin
export default {"donators":"donators_donators__y2hyx","row":"donators_row__X3Jzm","user":"donators_user__fvUtV","amount":"donators_amount__H3Imm"};